export enum STORAGE_KEYS {
  SOLO = 'SOLO',
  SOLO_APP_KEY = 'SOLO_APP_KEY',
  SOLO_APP_CONCEPT = 'SOLO_APP_CONCEPT',
  SOLO_APP_USER = 'SOLO_APP_USER',
  SOLO_APP_USER2 = 'SOLO_APP_USER2',
  SOLO_APP_USER_ROLE = 'SOLO_APP_USER_ROLE',
  API_DOMAIN = 'api-domain'
}

export const getFromStorage = (key: string) => {
  return JSON.parse(localStorage.getItem(key) || '{}');
};

export const storeInStorage = (key: string, data: any) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const clearStorage = () => {
  localStorage.clear();
};
